"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "piedimonte-matese": {
    "3f01401f": [{
      "hkey": "83d643ee",
      "slug": "piedimonte-matese",
      "name": "Piedimonte Matese",
      "primary": true,
      "skipSearch": false
    }],
    "bocca-della-selva": [{
      "hkey": "83d643ee",
      "slug": "piedimonte-matese",
      "name": "Piedimonte Matese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7cf99d57": [{
      "hkey": "83d643ee",
      "slug": "piedimonte-matese",
      "name": "Piedimonte Matese",
      "primary": true,
      "skipSearch": false
    }],
    "sella-del-perrone": [{
      "hkey": "83d643ee",
      "slug": "piedimonte-matese",
      "name": "Piedimonte Matese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "60389ee6": [{
      "hkey": "83d643ee",
      "slug": "piedimonte-matese",
      "name": "Piedimonte Matese",
      "primary": true,
      "skipSearch": false
    }],
    "sepicciano": [{
      "hkey": "83d643ee",
      "slug": "piedimonte-matese",
      "name": "Piedimonte Matese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;